import { LayoutHOC } from 'base/ui/layout/layout';
import { createMatchCardCommandDetail } from './matchCardCommandDetail';

export const createMatchCardCommandDetailPage = (layoutHOC: LayoutHOC) => {
  return layoutHOC(createMatchCardCommandDetail());
};
